/** 课程分类API */
import type { Api } from '@/typings/api';
import { post } from '../../request';
const prefix = '/school/lectureCategory';
/**
 * 分页查询课程分类
 *
 * @param params 查询参数
 */
export const findPage: Api.CommonMethods.FindPage<Api.School.LectureCategory> = params => {
  return post(`${prefix}/findPage`, params);
};
/**
 * 查询课程分类列表
 *
 * @param params 查询参数
 */
export const findAll: Api.CommonMethods.FindAll<Api.School.LectureCategory> = params => {
  return post(`${prefix}/findAll`, params);
};
/**
 * 查询单个课程分类
 *
 * @param id 课程分类ID
 * @param column 查询字段
 */
export const findOne: Api.CommonMethods.FindOne<Api.School.LectureCategory> = (id: string, column?: string[]) => {
  return post(`${prefix}/findOne`, { id, column });
};
/**
 * 保存课程分类
 *
 * @param params 课程分类信息
 */
export const doSave: Api.CommonMethods.Save = params => {
  return post(`${prefix}/save`, params);
};
/**
 * 更新课程分类信息
 *
 * @param params 课程分类信息
 */
export const doUpdate: Api.CommonMethods.Update = params => {
  return post(`${prefix}/update`, params);
};
/**
 * 删除课程分类
 *
 * @param id 课程分类ID
 */
export const doDelete: Api.CommonMethods.Delete = id => {
  return post(`${prefix}/delete?id=${id}`);
};
/**
 * 批量删除课程分类
 *
 * @param ids 课程分类ID数组
 */
export const doBatchDelete: Api.CommonMethods.BatchDelete = ids => {
  return post(`${prefix}/deleteList`, { ids });
};

export default {
  findPage,
  findOne,
  doSave,
  doUpdate,
  doDelete,
  doBatchDelete
};
